module.exports = __webpack_public_path__ + "img/play.a3ef00c4.png";